
import { defineComponent } from "vue";
import NamedSection from "../publisher/NamedSection.vue";
import DeveloperProfileSection from "./DeveloperProfileSection.vue";

export default defineComponent({
    components: {
        NamedSection,
        DeveloperProfileSection,
    },
    props: {
        developerName: {
            type: String,
            required: false,
        },
        editing: {
            type: Boolean,
            required: true,
        },
        developerNamePrevious: {
            type: String,
            required: false,
        },
    },
    computed: {
        developerNameValue: {
            get() {
                return this.$props.developerName;
            },
            set(value: string) {
                this.$emit("update:developerName", value);
            },
        },
    },
    data() {
        return {
            validationRules: [
                (text: string): string | boolean => !!text || "Required",
                (text: string): string | boolean => text.length <= 100 || "Maximum 100 characters",
            ],
        };
    },
});
